import NatNalComponent from '../../Components/Home/NatNalComponent/NatNalComponent';
import { useAppSelector } from '../../Hooks/Hooks';
import { RootState } from '../../Redux/Store';
import { TNatNalProps } from './NatNal.type';
import './NatNal.scss';

const NatNal = (props: TNatNalProps) => {
  const showBanner = useAppSelector((state: RootState) => state.ContentOrConfig?.showBanner);
  return (
    <div className={`NatNal ${showBanner ? ' AlertBannerVisible' : ''}`}>
      <NatNalComponent />
    </div>
  );
};

export default NatNal;
